import { Button, Col, Form, Input, Row, Select } from "antd"
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { setHeaderName } from "../../../services/SetHeaderName";
import { Editor } from "./components/Editor";

export const NutrionistEmailTemplate = () => {
    const [form] = Form.useForm();
    const { id } = useParams();
    const { Option } = Select;

    const [editorData, setEditorData] = useState();
    const [templateId, setTemplateID] = useState();

    const onChange = (data) => {
        setEditorData(data)
    }


    const data = [
        {
            id: '1001',
            name: 'Welcome Emailer',
            template_strings: '$ClientName, $NutritionistName, $Date, $PackageName',
            template: '<h1>Welcome $ClientName<h1>',
            userType: "Nutrionist",
            status: false,
        },
        {
            id: '1002',
            name: 'Unable to Reach You',
            template_strings: '$ClientName, $NutritionistName, $Date, $PackageName',
            template: '<h1>Unable to Reach You $ClientName<h1>',
            userType: "Nutrionist",
            status: true,
        },
    ];

    useEffect(() => {
        // Nutrionist Email Template
        setHeaderName("Email Template")

        if (data.length > 0) {
            form.setFieldValue('Template', data[0].id)
            form.setFieldValue('email_subject', data[0].name)
            setEditorData(data[0].template)
        }
    }, []);
    const onFinish = (values) => {
        values.editorData =editorData
    };
    const resetData = () => {
        form.resetFields()
    };


    const getData = (id) => {
        let record = data.find(element => element.id == id)
        // setEditorData(data)
        if (record) {
            form.setFieldValue('email_subject', record.name);
            setEditorData(record.template)
        }
        return record
    }
    return (
        <>
            <div className="AddEmailTemplate">
                <Form
                    name="AddEmailTemplate"
                    className="AddEmailTemplateForm"
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                        <Col xs={24} md={16} xl={11} xxl={8}>
                            <label className="form-input-label">
                                Choose Email Template
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="Template"
                                rules={[{ required: true, message: "Please Select Template!" }]}
                            >
                                <Select
                                    className="w-100 mt-2"
                                    // value={regType}
                                    onChange={(e) => getData(e)}
                                >
                                    {/* <Option value="" disabled hidden>
                                        Select Template
                                    </Option> */}
                                    {
                                        data.map((element) =>
                                            element.userType !== "Admin" &&
                                            <Option value={element.id}>{element.name}</Option>
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={16} xl={11} xxl={16}>
                            <label className="form-input-label">
                                Email Subject
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="email_subject"
                                rules={[
                                    { required: true, message: "Please insert Email Subject!" },
                                ]}
                            // initialValue={template.name}
                            >
                                <Input placeholder="Enter Email Subject" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={16} xl={11} xxl={24}>
                            <label className="form-input-label">
                                Editor
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Editor onChange={onChange} editorData={editorData} />
                        </Col>
                        <Col span={24} className="text-center">
                            <Button htmlType="submit" className="submit-button b-0 rounded">
                                UPDATE
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>

        </>
    )
}

